// Platform contact form types - mirrors POST /api/v1/public/contact-messages (issue #241).
import type { Locale } from '@/i18n'

export const PlatformContactTopic = {
  EventPlanning: 'event_planning',
  ParticipantAccountOrPayment: 'participant_account_or_payment',
  PartnershipsAndPress: 'partnerships_and_press',
  Other: 'other',
} as const

export type PlatformContactTopic = typeof PlatformContactTopic[keyof typeof PlatformContactTopic]

export const PLATFORM_CONTACT_TOPICS: readonly PlatformContactTopic[] = Object.values(PlatformContactTopic)

export interface ContactMessagePayload {
  name: string
  email: string
  topic: PlatformContactTopic
  message: string
  organisation_name?: string | null
  locale: Locale
}
